import { Station } from '@mi-front/core';
import { SelectField } from '@mi-front/ui';
import { useField } from 'formik';
import { useIntl } from 'react-intl';

export const StationsSelect = ({
  name = 'stations',
  stations,
  maxSelected,
  multiple,
  label,
  isClearable,
}: {
  name?: string;
  stations: readonly Station[];
  maxSelected?: number;
  multiple?: boolean;
  isClearable?: boolean;
  label?: string;
}) => {
  const { $t } = useIntl();
  const [{ value }] = useField(name);

  return (
    <SelectField
      isSearchable
      name={name}
      label={label ?? $t({ id: 'common.stations', defaultMessage: 'Emisoras' })}
      placeholder={
        maxSelected
          ? undefined
          : $t({
              id: 'common.allStations',
              defaultMessage: 'Todas las estaciones',
            })
      }
      options={stations}
      multiple={multiple}
      isClearable={isClearable}
      getOptionValue={(station) => station.id}
      getOptionLabel={(station) => station.name}
      isOptionDisabled={() =>
        multiple ? Boolean(maxSelected && value.length >= maxSelected) : false
      }
    />
  );
};
